


















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { IcoachSkill, IcoachSkillDirections, IcoachSkillQuestion } from '@/interfaces/IcoachInterfaces'
import { IcoachData } from '@/interfaces/LocalStorageInterfaces'
import IcoachService from '@/services/IcoachService'

@Component({ name: 'IcoachSkillForm' })
export default class IcoachSkillForm extends Vue {
  @Prop({ required: true })
  icoachSkill!: IcoachSkill
  @Prop({ required: true })
  icoachUserData!: IcoachData
  @Prop({ required: true })
  stepId!: number

  questions: IcoachSkillQuestion[] = []
  resultList: object = {}
  totalScore: number | null = null

  async created () {
    await this.uploadQuestions()
  }

  async submit () {
    if (!await this.$validator.validateAll()) {
      return
    }

    try {
      const result = await IcoachService.sendScoreForm(
        this.resultList,
        this.icoachSkill.id,
        this.icoachUserData.icoachUserId
      )

      this.resetForm()
      this.totalScore = result.score
      this.$store.commit('icoach/updateIcoachProgress', {
        currentSkill: this.icoachSkill.id,
        currentStep: this.stepId
      })
    } catch (error) {
      throw error
    }
  }

  async uploadQuestions () {
    try {
      const totalScore = await IcoachService.getIcoachSkillScore(this.icoachSkill.id, this.icoachUserData.icoachUserId)
      if (totalScore && totalScore.score) {
        this.totalScore = totalScore.score
      }

      this.questions = await IcoachService.getIcoachSkillQuestions(this.icoachSkill.id)
    } catch (error) {
      if ('response' in error && error.response.status === 400) {
        this.handleScoreErrors(error.response.data)
      }
    }
  }

  handleScoreErrors (data: object) {
    // todo::add handle logic
  }

  @Emit()
  changeStep (direction: IcoachSkillDirections) {
    return direction
  }

  resetForm () {
    this.$validator.reset()
    this.resultList = {}
  }

  retakeSkill () {
    this.totalScore = null
  }

  get formattedScore () {
    return Number(this.totalScore).toString()
  }
}
